<!-- Topbar Button -->
@if (availableTours.length > 0) {
  <button
    class="p-link layout-topbar-button feature-tour-button"
    [ngClass]="{ 'has-new-tours': hasNewTours }"
    type="button"
    (click)="togglePanel($event)"
    [pTooltip]="hasNewTours ? newFeaturesAvailableTooltip : featureToursTooltip"
  >
    <i class="pi pi-info-circle"></i>
  </button>

  <!-- Feature Tour Panel -->
  <p-overlayPanel
    #tourPanel
    [style]="{ width: '400px' }"
    styleClass="panel-content"
  >
    <ng-template pTemplate="content">
      <div class="panel-header">
        <span class="panel-title">{{ dialogTitle }}</span>
      </div>

      <!-- Panel Content -->
      <div class="tour-list-container">
        <p-accordion [activeIndex]="0">
          @for (tour of availableTours; track tour.id) {
            <p-accordionTab>
              <ng-template pTemplate="header">
                <span>{{ tour.title }}</span>
                @if (!featureTourService.hasTourBeenViewed(tour.id)) {
                  <span class="tour-badge">NEW</span>
                }
              </ng-template>
              <p>{{ tour.description }}</p>
              <div class="tour-actions">
                <button
                  type="button"
                  pButton
                  [label]="startTourButtonLabel"
                  icon="pi pi-play"
                  (click)="startTour(tour.id)"
                ></button>
              </div>
            </p-accordionTab>
          }
        </p-accordion>
      </div>
    </ng-template>
  </p-overlayPanel>
}
